if (!customElements.get("collection-paginate-v2")) {
  customElements.define(
    "collection-paginate-v2",
    class CollectionPaginateV2 extends HTMLElement {
      constructor() {
        super();

        this.productGrid = this.querySelector("#product-grid");
        this.currentPage = parseInt(this.dataset.pageNum);
        this.totalPages = parseInt(this.dataset.pageTotal);
        this.inProgress = false;

        this.allProducts = null;
        this.filteredProducts = null;
        this.productsPerPage = parseInt(this.dataset.productsPerPage) || 24;
        this.collectionHandle = this.dataset.collectionHandle || window.location.pathname.split('/collections/')[1].split('/')[0];
        this.init();
      }

      async init() {
        const sizeTag = this.getSelectedSizeTag();
        if (sizeTag) {
          // Initialize Custom JS Pagination
          this.productGrid.innerHTML = '<li>Loading...</li>';
          this.updateGrid(1);

          document.addEventListener('click', (e) => {
            if (e.target.matches('.filter-tag')) {
              setTimeout(() => this.updateGrid(1), 100);
            }
          });
        } else {
        // Initialize Liquid Pagination
          this.initPaginationButtons();
        }
      }

      getSelectedSizeTag() {
        const urlParams = new URLSearchParams(window.location.search);
        for (const [key, value] of urlParams.entries()) {
          if (key === 'filter' && value.startsWith('size_')) {
            const result = value.replace('size_', '');
            return result;
          }
        }
        const active = document.querySelector('.filter-tag.active[data-tag^="size_"]');
        if (active) {
          const result = active.dataset.tag.replace('size_', '');
          return result;
        }
        const pathSegments = window.location.pathname.split('/');
        const lastSegment = pathSegments[pathSegments.length - 1];
        const sizeMatch = lastSegment.match(/size_([a-zA-Z0-9]+)/);
        if (sizeMatch) {
          const result = sizeMatch[1];
          return result;
        }
        return null;
      }

      async fetchAllProducts() {
        let products = [];
        let page = 1;
        let more = true;
        const baseUrl = `/collections/${this.collectionHandle}/products.json?limit=250`;
        while (more) {
          const res = await fetch(baseUrl + `&page=${page}`);
          const data = await res.json();
          products = products.concat(data.products);
          more = data.products.length === 250;
          page++;
        }
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/');
        const lastSegment = pathSegments[pathSegments.length - 1];
        let tagFilters = [];
        
        if (lastSegment && lastSegment.includes('+')) {
          tagFilters = lastSegment.split('+').filter(tag => !tag.startsWith('size_'));
        } else if (lastSegment && lastSegment.length && !lastSegment.startsWith('size_') && lastSegment !== this.collectionHandle) {
          tagFilters = [lastSegment];
        }

        if (tagFilters.length) {
          products = products.filter(product => {
            return tagFilters.every(tag => product.tags.map(t => t.toLowerCase()).includes(tag.toLowerCase()));
          });
        }
        return products;
      }

      filterBySize(products, sizeTag) {
        if (!sizeTag) {
          return products;
        }
        const normalizedTag = sizeTag.trim().toLowerCase();
        const filtered = products.filter(product => {
          return product.variants.some(variant => {
            if (!variant.available) return false;

            let match = false;
            if (variant.title && (variant.title.trim().toLowerCase() === normalizedTag)) {
              match = true;
            }
            return match;
          });
        });

        return filtered;
      }

      async renderGrid(products, page) {
        this.productGrid.innerHTML = '';
        if (!products || products.length === 0) {
          this.productGrid.innerHTML = '<li class="error">No products found</li>';
          return;
        }
        const start = (page - 1) * this.productsPerPage;
        const end = start + this.productsPerPage;
        const pageProducts = products.slice(start, end);

        const cardPromises = pageProducts.map(async (p) => {
          if (!p.handle) return '';
          const url = `/products/${p.handle}`;
          try {
            const response = await fetch(url);
            const html = await response.text();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            const card = tempDiv.querySelector('#product-card-ajax');
            return card ? card.innerHTML : '<li class="error">No product card found</li>';
          } catch (err) {
            return '<li class="error">Error loading product</li>';
          }
        });

        const cardsHTML = await Promise.all(cardPromises);
        this.productGrid.innerHTML = cardsHTML.join('');
      }

      renderPagination(products, currentPage) {
        if (!products || products.length === 0) {
          this.querySelector('.pagination').innerHTML = '';
          return;
        }
        const totalPages = Math.ceil(products.length / this.productsPerPage);
        const container = this.querySelector('.pagination');
        if (!container) {
          return;
        }
        container.innerHTML = '';

        const prevBtn = document.createElement('button');
        prevBtn.className = 'pagination-prev' + (currentPage === 1 ? ' disabled' : '');
        prevBtn.disabled = currentPage === 1;
        prevBtn.innerHTML = '&lt;';
        prevBtn.onclick = () => this.updateGrid(currentPage - 1);
        container.appendChild(prevBtn);

        for (let i = 1; i <= totalPages; i++) {
          const pageBtn = document.createElement('button');
          pageBtn.className = 'pagination-page' + (i === currentPage ? ' active' : '');
          pageBtn.textContent = i;
          pageBtn.onclick = () => this.updateGrid(i);
          container.appendChild(pageBtn);
        }

        const nextBtn = document.createElement('button');
        nextBtn.className = 'pagination-next' + (currentPage === totalPages ? ' disabled' : '');
        nextBtn.disabled = currentPage === totalPages;
        nextBtn.innerHTML = '&gt;';
        nextBtn.onclick = () => this.updateGrid(currentPage + 1);
        container.appendChild(nextBtn);
      }

      async updateGrid(page = 1) {
        const allProducts = await this.fetchAllProducts();

        if (!allProducts) return;
        this.currentPage = page;
        const sizeTag = this.getSelectedSizeTag();
        this.filteredProducts = this.filterBySize(allProducts, sizeTag);
        this.renderGrid(this.filteredProducts, this.currentPage);
        this.renderPagination(this.filteredProducts, this.currentPage);

        // Update URL without page reload
        const url = new URL(window.location);
        url.searchParams.set('page', page);
        window.history.pushState({}, '', url);

        // Scroll to top of page
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      // Initialize Liquid Pagination buttons and their event listeners

      initPaginationButtons() {
        const prevButton = this.querySelector('.pagination-prev');
        const nextButton = this.querySelector('.pagination-next');
        const pageButtons = this.querySelectorAll('.pagination-page');

        if (prevButton) {
          prevButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (!this.inProgress && this.currentPage > 1) {
              this.navigateToPage(this.currentPage - 1);
            }
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (!this.inProgress && this.currentPage < this.totalPages) {
              this.navigateToPage(this.currentPage + 1);
            }
          });
        }

        if (pageButtons) {
          pageButtons.forEach(button => {
            button.addEventListener('click', (e) => {
              e.preventDefault();
              const pageNum = parseInt(button.dataset.page);
              if (!this.inProgress && pageNum !== this.currentPage) {
                this.navigateToPage(pageNum);
              }
            });
          });
        }
      }

      updatePaginationUI() {
        const prevButton = this.querySelector('.pagination-prev');
        const nextButton = this.querySelector('.pagination-next');
        const pageButtons = this.querySelectorAll('.pagination-page');

        if (prevButton) {
          prevButton.classList.toggle('disabled', this.currentPage <= 1);
        }

        if (nextButton) {
          nextButton.classList.toggle('disabled', this.currentPage >= this.totalPages);
        }

        if (pageButtons) {
          pageButtons.forEach(button => {
            const pageNum = parseInt(button.dataset.page);
            button.classList.toggle('active', pageNum === this.currentPage);
          });
        }
      }

      async navigateToPage(pageNum) {
        if (this.inProgress) return;

        try {
          this.inProgress = true;
          this.productGrid.classList.add('loading');

          // Get the collection page data
          const data = await fetch(`${window.location.pathname}?page=${pageNum}`).then(
            (response) => response.text()
          );

          const paginateHTML = document.createElement("div");
          paginateHTML.innerHTML = data;
          const newCollData = paginateHTML.querySelector("collection-paginate-v2");

          // Update the product grid
          this.productGrid.innerHTML = newCollData.productGrid.innerHTML;

          // Update pagination
          this.currentPage = pageNum;
          this.updatePaginationUI();

          // Update URL without page reload
          const url = new URL(window.location);
          url.searchParams.set('page', pageNum);
          window.history.pushState({}, '', url);

          // Scroll to top of page
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (err) {
          console.error('Error loading page:', err);
        } finally {
          this.inProgress = false;
          this.productGrid.classList.remove('loading');
        }
      }
    }
  );
}
